import {Utils} from '@astek/utils';
import {JsonConfigInterface} from './json-config-interface';
import {InfusionConfig, InfusionConfigJson} from './infusion-config';
import {ResultsConfig, ResultsConfigJson} from './results-config';
import {CommentIndicatorConfig, CommentIndicatorConfigJson} from './comment-indicator-config';
import {PressureGraphConfig, PressureGraphConfigJson} from './pressure-graph-config';

export type MeanPressureGraphConfigJson = PressureGraphConfigJson & {
  infusion: InfusionConfigJson;
  basalResults: ResultsConfigJson;
  plateauResults: ResultsConfigJson;
  commentIndicator: CommentIndicatorConfigJson;
};

export class MeanPressureGraphConfig extends PressureGraphConfig
  implements JsonConfigInterface<MeanPressureGraphConfigJson> {

  public readonly infusion: InfusionConfig = new InfusionConfig();
  public readonly basalResults: ResultsConfig = new ResultsConfig();
  public readonly plateauResults: ResultsConfig = new ResultsConfig();
  public readonly commentIndicator: CommentIndicatorConfig = new CommentIndicatorConfig();

  constructor(json?: MeanPressureGraphConfigJson) {
    super(json);
    if (!Utils.isNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public override deserializeJson(json: MeanPressureGraphConfigJson): void {
    super.deserializeJson(json);
    this.infusion.deserializeJson(json.infusion);
    this.basalResults.deserializeJson(json.basalResults);
    this.plateauResults.deserializeJson(json.plateauResults);
    this.commentIndicator.deserializeJson(json.commentIndicator);
  }
}
